module.exports = __webpack_public_path__ + "static/media/home-3.6d68dd65.mp4";